import { TYPE_BOOLEAN } from './input-types';

export const id = 'isShipped';
export const apiKey = 'IsShipped';
export const type = TYPE_BOOLEAN;

export const isShipped = {
  id,
  apiKey,
  type,
};
